import baseAPI from '@/http'

const router = 'api/salatempo'

export const SalaTempoAPI = {
  create: (data) => baseAPI.post(router + '/cadastrar-tempo', data),
  update: (data) => baseAPI.put(router + '/atualizar-tempo', data),
  getbyMunicipio: (id) => baseAPI.get(`${router}/obter-tempo-por-municipio/${id}`),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(router)

}
